import { Deserializable } from '../../lib//models/deserializable';

export class ProductSpecialFeatureDto implements Deserializable {
  public SpecialFeatureName: string;
  public Value: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
